"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const Utils_1 = require("../../../../utils/Utils");
const Dropdown_1 = __importDefault(require("react-bootstrap/Dropdown"));
const bs_1 = require("react-icons/bs");
const CustomPagination_1 = require("../../../Common/CustomPagination");
const signalement_api_1 = require("../../../../utils/api/signalement/signalement.api");
const UseCrudSignalement_1 = require("../requestForm/UseCrudSignalement");
const EmptyAlert_1 = __importDefault(require("../../../Shared/Alerts/EmptyAlert"));
const react_medium_image_zoom_1 = __importDefault(require("react-medium-image-zoom"));
const TableSkeleton_1 = __importDefault(require("../../AdminShared/TableSkeleton"));
const AddSignalementModal_1 = __importDefault(require("../Modals/AddSignalementModal"));
const ShowSignalementModal_1 = __importDefault(require("../Modals/ShowSignalementModal"));
require("./SignalementsTable.css");
const SignalementsTable = () => {
    const [page, setPage] = (0, react_1.useState)(1);
    const [perPage, setPerPage] = (0, react_1.useState)(10);
    const { data = { data: [], count: 0 }, isLoading } = (0, signalement_api_1.useGetSignalementsQuery)({});
    const filteredData = data.data || [];
    const paginatedData = filteredData.slice((page - 1) * perPage, page * perPage);
    const contentFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "formatter__wrapper" }, (row === null || row === void 0 ? void 0 : row.content) && (react_1.default.createElement("div", { className: "d-flex flex-column gap-1" },
            react_1.default.createElement("p", { className: "m-0" }, (0, Utils_1.truncateString)(row === null || row === void 0 ? void 0 : row.content, 80))))));
    };
    const imageFormatter = (cell, row) => {
        if (row === null || row === void 0 ? void 0 : row.media_image) {
            return (react_1.default.createElement("div", { className: "image__wrapper" },
                react_1.default.createElement(react_medium_image_zoom_1.default, null,
                    react_1.default.createElement("img", { src: row.media_image, alt: "illustration", className: "custom-image-table", "data-zoomable": true, style: { width: "80px", height: "60px", objectFit: "cover" } }))));
        }
        return react_1.default.createElement("span", { className: "text-muted" }, "N/A");
    };
    const videoFormatter = (cell, row) => {
        if (row === null || row === void 0 ? void 0 : row.media_video) {
            return (react_1.default.createElement("div", { className: "video__wrapper" },
                react_1.default.createElement("video", { src: row.media_video, controls: true, style: { width: "120px", height: "80px", borderRadius: "4px" } })));
        }
        return react_1.default.createElement("span", { className: "text-muted" }, "N/A");
    };
    const audioFormatter = (cell, row) => {
        if (row === null || row === void 0 ? void 0 : row.media_audio) {
            return (react_1.default.createElement("div", { className: "audio__wrapper", style: { width: "200px" } },
                react_1.default.createElement("audio", { src: row.media_audio, controls: true, preload: "none", style: { width: "100%" } }, "Votre navigateur ne supporte pas l'\u00E9l\u00E9ment audio.")));
        }
        return react_1.default.createElement("span", { className: "text-muted" }, "N/A");
    };
    const authorFormatter = (cell, row) => {
        var _a;
        return (react_1.default.createElement("div", null, ((_a = row === null || row === void 0 ? void 0 : row.admin) === null || _a === void 0 ? void 0 : _a.fullname) || (row === null || row === void 0 ? void 0 : row.added_by) || "N/A"));
    };
    const formatDate = (date) => {
        const moment = require("moment");
        moment.locale("fr");
        if (!date)
            return "";
        const dateObj = moment(date);
        if (!dateObj.isValid())
            return "";
        return (0, Utils_1.capitalize)(dateObj.format("dddd D MMMM YYYY - HH:mm"));
    };
    const actionFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "actionformatter__wrapper" },
            react_1.default.createElement(Dropdown_1.default, null,
                react_1.default.createElement(Dropdown_1.default.Toggle, { id: "dropdown-basic" },
                    react_1.default.createElement(bs_1.BsThreeDots, null)),
                react_1.default.createElement(Dropdown_1.default.Menu, null,
                    react_1.default.createElement(ShowSignalementButton, { item: row }),
                    react_1.default.createElement(EditSignalementButton, { item: row }),
                    react_1.default.createElement(DeleteSignalementButton, { id: row === null || row === void 0 ? void 0 : row.id })))));
    };
    const columns = [
        {
            dataField: "content",
            text: "Contenu",
            formatter: contentFormatter,
            headerStyle: () => {
                return {
                    width: "250px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "media_image",
            text: "Image",
            formatter: imageFormatter,
            headerStyle: () => {
                return {
                    width: "100px",
                    whiteSpace: "normal",
                    textAlign: "center",
                };
            },
        },
        {
            dataField: "media_video",
            text: "Vidéo",
            formatter: videoFormatter,
            headerStyle: () => {
                return {
                    width: "140px",
                    whiteSpace: "normal",
                    textAlign: "center",
                };
            },
        },
        {
            dataField: "media_audio",
            text: "Audio",
            formatter: audioFormatter,
            headerStyle: () => {
                return {
                    width: "220px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "added_by",
            text: "Auteur",
            formatter: authorFormatter,
            headerStyle: () => {
                return {
                    width: "150px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "created_at",
            text: "Date de création",
            formatter: (cell) => formatDate(cell),
            headerStyle: () => {
                return {
                    width: "200px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "id",
            text: "Action",
            formatter: actionFormatter,
            headerStyle: () => {
                return {
                    width: "100px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !!isLoading && react_1.default.createElement(TableSkeleton_1.default, { headers: columns }),
        !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "col-lg-12" },
                react_1.default.createElement("div", { className: "admin-table" },
                    react_1.default.createElement(react_bootstrap_table_next_1.default, { keyField: "id", data: paginatedData || [], columns: columns, condensed: true, hover: true, wrapperClasses: "table-responsive admin-table", noDataIndication: () => (react_1.default.createElement(EmptyAlert_1.default, { textualContent: "Aucune donn\u00E9es trouv\u00E9es" })) }),
                    react_1.default.createElement("div", { className: "custom-pagination-container" },
                        react_1.default.createElement(CustomPagination_1.CustomPagination, { nbPages: filteredData === null || filteredData === void 0 ? void 0 : filteredData.length, page: page, onChange: (page, perPage) => {
                                setPerPage(perPage);
                                setPage(page);
                            }, perPage: perPage }))))))));
};
const EditSignalementButton = ({ item }) => {
    const [showEditSignalementModal, setShowEditSignalementModal] = (0, react_1.useState)(false);
    const handleShowEditSignalementModal = () => {
        setShowEditSignalementModal(true);
    };
    const handleCloseEditSignalementModal = () => {
        setShowEditSignalementModal(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dropdown_1.default.Item, { onClick: handleShowEditSignalementModal }, "Modifier"),
        react_1.default.createElement(AddSignalementModal_1.default, { addSignalement: showEditSignalementModal, setAddSignalement: handleCloseEditSignalementModal, item: item })));
};
const DeleteSignalementButton = ({ id }) => {
    const onDelete = (0, UseCrudSignalement_1.UseDeleteSignalement)(id);
    return react_1.default.createElement(Dropdown_1.default.Item, { onClick: () => onDelete() }, "Supprimer");
};
const ShowSignalementButton = ({ item }) => {
    const [showSignalementModal, setShowSignalementModal] = (0, react_1.useState)(false);
    const handleShowSignalementModal = () => {
        setShowSignalementModal(true);
    };
    const handleCloseSignalementModal = () => {
        setShowSignalementModal(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dropdown_1.default.Item, { onClick: handleShowSignalementModal }, "Voir les d\u00E9tails"),
        react_1.default.createElement(ShowSignalementModal_1.default, { show: showSignalementModal, handleClose: handleCloseSignalementModal, item: item })));
};
exports.default = SignalementsTable;
